module.exports = __webpack_public_path__ + "static/media/neutral_happy.11076b48.svg";